var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-button button-basket goal-goto-basket",on:{"click":_vm.openBasket}},[(_vm.total_quantity > 0)?_c('span',{staticClass:"balloon basket-total"},[_vm._v(_vm._s(_vm.total_order_sum))]):_vm._e(),_c('span',{staticClass:"pp-icon pp-icon-basket"})])
}
var staticRenderFns = []

export { render, staticRenderFns }